import React, { useState, useEffect } from "react";
import axios from "axios";
import { Footer, Navbar } from "../components";
import { uploadFile } from "../firebase";

const Pruebas = () => {
  const [nombre, setNombre] = useState("");
  const [precio, setPrecio] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [stock, setStock] = useState("");
  const [imagen, setImagen] = useState("");
  const [productoId, setProductoId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showInsertForm, setShowInsertForm] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [file, setFile] = useState(null);
  const [nombreCategoria, setNomCate] = useState("");
  const [descripcionCategoria, setDescCate] = useState("");
  const [nombreCaracteristica, setNomCaract] = useState("");
  const [descripcionCaracteristica, setDescCaract] = useState("");
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [categorias, setCategorias] = useState([]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const uniqueName = `${nombre}-${Date.now()}-${Math.random()}`;
      const link = await uploadFile(file, uniqueName);
      console.log(imagen, link);
      const response = await axios.post(
        "https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/regproducto",
        {
          nombre_producto: nombre,
          precio_producto: precio,
          descripcion_producto: descripcion,
          stock_producto: stock,
          imagen_producto: link,
          estatus: 1,
        }
      );

      const responseData = response.data;
      await fetchData();
      if (responseData.success) {
        console.log("Producto registrado correctamente");
        setShowInsertForm(false);
        setShowTable(true);
        // Realizar las acciones necesarias después de registrar el producto
      } else {
        console.error("Error al registrar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }

    // Reiniciar el form
    setNombre("");
    setPrecio("");
    setDescripcion("");
    setStock("");
    setImagen("");
    setFile(null);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    try {
      const uniqueName = `${nombre}-${Date.now()}-${Math.random()}`;
      let link = imagen; // Mantener el enlace existente por defecto
      if (file) {
        link = await uploadFile(file, uniqueName);
      }
      const response = await axios.put(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/actproducto/${productoId}`,
        {
          nombre_producto: nombre,
          precio_producto: precio,
          descripcion_producto: descripcion,
          stock_producto: stock,
          imagen_producto: link,
        }
      );

      const responseData = response.data;
      await fetchData();
      if (responseData.success) {
        console.log("Producto actualizado correctamente");
        // Realizar las acciones necesarias después de actualizar el producto
        setShowUpdateForm(false);
      } else {
        console.error("Error al actualizar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }

    // Reiniciar el form
    setNombre("");
    setPrecio("");
    setDescripcion("");
    setStock("");
    setImagen("");
    setFile(null);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/eliproducto/${id}`
      );

      const responseData = response.data;
      if (responseData.success) {
        console.log("Producto eliminado correctamente");
        await fetchData();
        // Realizar las acciones necesarias después de eliminar el producto
      } else {
        console.error("Error al eliminar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtproductos"
      );
      const responseData = response.data;
      setData(responseData.data);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
    setLoading(false);
  };

  const handleSubmitFormCate = async () => {
    try {
      const response = await axios.post("https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/registrarcategoria", {
        nombre_categoria: nombreCategoria,
        descripcion_categoria: descripcionCategoria,
        id_producto: productoId,
      });
      const responseData = response.data;
      if (responseData.success) {
        await fetchCategorias(productoId)
        console.log("Categoría registrada y asignada correctamente");
        // Realizar las acciones necesarias después de registrar y asignar la categoría
      } else {
        console.error("Error al registrar y asignar la categoría:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };
  
  

  const handleSubmitFormCaract = async () => {
    try {
      const response = await axios.post(
        "https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/registrarcaracteristica",
        {
          nombre_caracteristica: nombreCaracteristica,
          valor_caracteristica: descripcionCaracteristica,
          id_producto: productoId,
        }
      );
      const responseData = response.data;
      if (responseData.success) {
        console.log("registrado correctamente");
        await fetchCaracteristicas(productoId)
        // Realizar las acciones necesarias después de registrar el producto
      } else {
        console.error("Error al registrar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const fetchCategorias = async (id) => {
    try {
      const response = await axios.get(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtcategorias/producto/${id}`
      );
      const responseData = response.data;
      setCategorias(responseData.data[0]);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const fetchCaracteristicas = async (id) => {
    try {
      const response = await axios.get(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtcaracteristicas/producto/${id}`
      );
      const responseData = response.data;
      setCaracteristicas(responseData.data[0]);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  const handleDeleteCate = async (id) => {
    try {
      const response = await axios.delete(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/eliprodcate/${productoId}/${id}`
      );
  
      const responseData = response.data;
      if (responseData.success) {
        console.log("Producto eliminado correctamente");
        await fetchCategorias(productoId);
        // Realizar las acciones necesarias después de eliminar el producto
      } else {
        console.error("Error al eliminar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };
  

  const handleDeleteCaract = async (id) => {
    try {
      const response = await axios.delete(
        `https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/eliprodcaract/${productoId}/${id}`
      );

      const responseData = response.data;
      if (responseData.success) {
        console.log("Producto eliminado correctamente");
        await fetchCaracteristicas(productoId);
        // Realizar las acciones necesarias después de eliminar el producto
      } else {
        console.error("Error al eliminar el producto:", responseData.error);
      }
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [showTable]);

  const manejarUpdate = async (id) => {
    // Lógica para actualizar el registro con el ID proporcionado
    const producto = data.find((product) => product.id === id);
    setProductoId(id);
    setNombre(producto.nombre);
    setPrecio(producto.precio);
    setDescripcion(producto.descripcion);
    setStock(producto.stock);
    setImagen(producto.imagen);
    setShowUpdateForm(true);
  
    await fetchCaracteristicas(id);
    await fetchCategorias(id);
  };
  
  const handleClick = async (id) => {
    await manejarUpdate(id);
  };

  const manejarDelete = async (id, event) => {
    event.stopPropagation();
    await handleDelete(id);
  };

  const manejarCancelar = () => {
    setShowUpdateForm(false);
    setNombre("");
    setPrecio("");
    setDescripcion("");
    setStock("");
    setImagen("");
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="container">
      <Navbar />
      {showUpdateForm ? (
        <div className="row">
          <div className="col-md-4">
            <form onSubmit={handleUpdate} className="container my-3 py-3">
              <h1 className="text-center">Actualizar Producto</h1>
              <hr />
              
              <div className="form my-3">
                <label>Nombre:</label>
                <input
                  type="text"
                  className="form-control"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Precio:</label>
                <input
                  type="number"
                  className="form-control"
                  value={precio}
                  onChange={(e) => setPrecio(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Descripción:</label>
                <input
                  type="text"
                  className="form-control"
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Stock:</label>
                <input
                  type="number"
                  className="form-control"
                  value={stock}
                  onChange={(e) => setStock(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Imagen:</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
              <div className="text-center">
                <button
                  className="my-2 px-4 mx-auto btn btn-dark"
                  type="submit"
                >
                  Actualizar Producto
                </button>
                <button
                  className="my-2 px-4 mx-auto btn btn-secondary"
                  onClick={() => manejarCancelar()}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
          <div className="col-md-4">
            <h1 className="text-center">Categorias</h1>
            <ul className="card container-fluid">
              {categorias.map((elemento) => (
                <li className="card my-2" key={elemento.id}>
                  <h3>{elemento.nombre}</h3>
                  <p>{elemento.descripcion}</p>
                  <div className="text-center">
                    <button
                      className="my-2 mx-2 px-4 btn btn-secondary"
                      onClick={() => {
                        handleDeleteCate(elemento.id)
                      }}
                    >
                      Eliminar
                    </button>
                  </div>
                </li>
              ))}
            </ul>
            <div className="card">
              <div className="card-body">
                <h2>Agregar Categoria</h2>
                <form onSubmit={handleSubmitFormCate}>
                  <div className="form-group">
                    <label>Nombre de la categoria</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nombreCategoria}
                      onChange={(e) => setNomCate(e.target.value)}
                    />
                    <label>Descripción de la categoria</label>
                    <input
                      type="text"
                      className="form-control"
                      value={descripcionCategoria}
                      onChange={(e) => setDescCate(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Guardar
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <h1 className="text-center">Caracteristicas</h1>
            <ul className="card container-fluid">
              {caracteristicas.map((elemento) => (
                <li className="card my-2" key={elemento.id}>
                  <h3>{elemento.nombre}</h3>
                  <p>{elemento.valor}</p>
                  <div className="text-center">
                    <button
                      className="my-2 mx-2 px-4 btn btn-secondary"
                      onClick={() => {
                        handleDeleteCaract(elemento.id);
                      }}
                    >
                      Eliminar
                    </button>
                  </div>
                </li>
              ))}
            </ul>
            <div className="card">
              <div className="card-body">
                <h2>Agregar Caracteristica</h2>
                <form onSubmit={handleSubmitFormCaract}>
                  <div className="form-group">
                    <label>Nombre de la caracteristica</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nombreCaracteristica}
                      onChange={(e) => setNomCaract(e.target.value)}
                    />
                    <label>Descripción de la categoria</label>
                    <input
                      type="text"
                      className="form-control"
                      value={descripcionCaracteristica}
                      onChange={(e) => setDescCaract(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Guardar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="container my-3 py-3">
          <h1 className="text-center">Registrar Producto</h1>
          <hr />
          <div className="row my-4">
            <div className="col-md-6 col-lg-4 col-sm-8 mx-auto">
              <div className="form my-3">
                <label>Nombre:</label>
                <input
                  type="text"
                  className="form-control"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Precio:</label>
                <input
                  type="number"
                  className="form-control"
                  value={precio}
                  onChange={(e) => setPrecio(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Descripción:</label>
                <input
                  type="text"
                  className="form-control"
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Stock:</label>
                <input
                  type="number"
                  className="form-control"
                  value={stock}
                  onChange={(e) => setStock(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label>Imagen:</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
              <div className="text-center">
                <button
                  className="my-2 px-4 mx-auto btn btn-dark"
                  type="submit"
                >
                  Registrar Producto
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
      <div className="container my-5">
        <table className="table table-bordered table-striped table-hover">
          <thead className="bg-primary text-light">
            <tr>
              <th>ID</th>
              <th>Imagen</th>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Descripción</th>
              <th>Stock</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {data.map((product) => (
              <tr key={product.id}>
                <td>{product.id}</td>
                <td>
                  <img
                    src={product.imagen}
                    alt={product.nombre}
                    width="50"
                    height="50"
                  />
                </td>
                <td>{product.nombre}</td>
                <td>{product.precio}</td>
                <td>{product.descripcion}</td>
                <td>{product.stock}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary mr-2"
                    onClick={ () => {
                      handleClick(product.id)
                    }}
                  >
                    Actualizar
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={(event) => manejarDelete(product.id, event)}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer />
    </div>
  );
};

export default Pruebas;
